import Socket from "./socket.js"      //socket对象
import Cache from "./cache.js"        //消息缓存池    
import Info from "./info-control.js"   //信息对象
import {instance} from 'src/config/axiosConfig.js'

// 连接成功的回调
Socket.open(function(){
    instance.get(`api/websocket/msg/user/unread`)
    .then(res=>{
        Socket.messageEvent(res.res_data);
    })
});
//websocket信息处理
Socket.onMessage(Cache.addInfo);  

//过滤后的信息处理
Cache.onMessage(Info.infoRelease);       

const funcs = [];  //登出回调函数
function do_logout(){  //执行登出回调
    for(let fun of funcs){
        fun();
    }
}

export default {
    build:Socket.build,   //建立websocket连接  并向后台传输用户信息
    close(){              //退出消息系统，  /关闭websocket连接，清空缓存
        Socket.close();
        Cache.clear();
        Info.clear();
        do_logout();
        funcs.splice(0,funcs.length);
        console.log(`socket关闭  消息缓存清空`)
    },   
    remove:Cache.remove,  //移除缓存池信息列表  降低压力
    get:Cache.get,   //拿消息缓存 
    listen:Info.listen,   //监听对应类型信息  可添加回调函数
    logout(fn){ //监听登出
        funcs.push(fn);
    }, 
};


// WEBPACK FOOTER //
// ./src/control/info/main.js